module.exports = __webpack_public_path__ + "themes/fq/fonts.css";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/fonts.css
// module id = 22
// module chunks = d-game